import { Component, CUSTOM_ELEMENTS_SCHEMA, Input, ViewChild } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { ChartModule } from 'primeng/chart';
import { DialogModule } from 'primeng/dialog';
import { CoilSheet, CoilSheetDataSets, Graph } from '../../shared/entities/coilSheet';
import { DropdownButtonComponent } from '../dropdown-button/dropdown-button.component';
import { ExportDialogComponent } from '../export-dialog/export-dialog.component';
import {
  ApexAxisChartSeries,
  ApexChart,
  ApexXAxis,
  ApexDataLabels,
  ApexYAxis,
  ApexFill,
  ApexMarkers,
  ApexStroke,
  NgApexchartsModule,
  ChartComponent,
  ApexAnnotations
} from "ng-apexcharts";
import { FormsModule } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { Utility } from '../../shared/entities/utils';
import { EventEmitterService } from '../../shared/services/event-emitter.service';
import { ExportData } from '../../shared/entities/export';
import { MeasurementsDataService } from '../../shared/services/measurements-data.service';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DefectDialogComponent } from '../defect-dialog/defect-dialog.component';

export type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  xaxis: ApexXAxis;
  dataLabels: ApexDataLabels;
  yaxis: ApexYAxis;
  fill: ApexFill;
  stroke: ApexStroke;
  markers: ApexMarkers;
  colors: string[];
  annotations: ApexAnnotations;
};

@Component({
  selector: 'app-coil-analytics',
  standalone: true,
  imports: [
    ButtonModule,
    ChartModule,

    DropdownButtonComponent,
    ExportDialogComponent,
    DefectDialogComponent,
    DialogModule,
    NgApexchartsModule,
    FormsModule,
    NgxSpinnerModule,
    MatIconModule,
    MatTooltipModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './coil-analytics.component.html',
  styleUrl: './coil-analytics.component.scss'
})
export class CoilAnalyticsComponent {
  chartOneSeries:any;
  cahrttwoSeries:any;
  regionMeasurementUnits: any = {};
  regionUnit: string = '';
  coilThicknessUpperTolerance: number = 0;
  coilThicknessLowerTolerance: number = 0;
  coilWidthUpperTolerance: number = 0;
  coilWidthLowerTolerance: number = 0;
  coilCrownUpperTolerance: number = 0;
  coilCrownLowerTolerance: number = 0;
  coilWedgeUpperTolerance: number = 0;
  coilWedgeLowerTolerance: number = 0;
  showInsufficientDisclaimer: boolean = false;
  showMediumDisclaimer: boolean = false;
  annotationData: any[] | undefined = [];
  selectionXaxislength:number=0;
  constructor(
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private eventEmitterService: EventEmitterService,
    private measurementsDataService: MeasurementsDataService) {
    this.regionMeasurementUnits = this.measurementsDataService.regionMeasurementUnits();
    this.measurementsDataService.getMeasurementsData.subscribe(unit => this.regionUnit = unit);
  }

  @ViewChild("chart", { static: false }) chart: ChartComponent | any;
  public chartOptions1!: Partial<ChartOptions> | any;
  public chartOptions2!: Partial<ChartOptions> | any;
  // Define Graph data by type
  dataSetMap: Map<string, Graph> = new Map<string, Graph>();
  coilLength: number | undefined = 0;
  coilSheetId: string = '';

  // Get selected coil from coil or order overview component
  @Input()
  get coil() {
    return this._coil;
  }
  set coil(value: CoilSheet) {
    this._coil = value;
    if (value?.coilSheetId) {
      this.coilSheetId = value.coilSheetId;
    }
    this.extractGraphData();
    if (this.availableGraphs.length > 0) {
      this.onSelectGraphEvent(this.availableGraphs[0]);
    }
  }

  graphLabels: { [key: string]: string } = {
    WIDTH_GRAPH: "Width",
    THICKNESS_GRAPH: "Thickness",
    CROWN_GRAPH: "Crown",
    WEDGE_GRAPH: "Wedge" 
  };

  private _coil: CoilSheet = {};

  selectedGraph: { key: string; label: string; } = { key: '', label: '' };
  availableGraphs: { key: string; label: string; }[] = [];

  showExportDialog: boolean = false;

  showDefectDialog:boolean =false;

  selectedGraphData: CoilSheetDataSets = {};

  graphType: any;

  showDialog() {
    this.emitExportData()
    this.showExportDialog = true;
  }

  showDialogDefect(){
    // this.emitExportData()
    this.showDefectDialog = true;
  }
  onDialogDefectClose(event: boolean){
    this.showDefectDialog = event;
  }
  onDialogClose(event: boolean) {
    this.showExportDialog = event;
  }

  emitExportData() {
    const exampleExportData: ExportData = {
      exportFrom: 'Coil',
      exportId: this.coilSheetId,
      selectedGraph: this.selectedGraph,
      coilSheetsToExport: [this.coil]
    };
    this.eventEmitterService.get<ExportData>('exportData').emit(exampleExportData);
  }

  extractGraphData() {
    this.availableGraphs = [];
    if (this.coil?.availableDataSetNames) {
      this.coil.availableDataSetNames.forEach((key: string) => {
        this.availableGraphs.push({ key: key, label: this.graphLabels[key] });
      });
    }
  }

  showErrorInResults = (error: any) => {
    this.spinner.hide();
    this.toastr.error(`Error: ${error.error.detail}`);
  }

  setGraphOptions() {
    this.graphType = this.selectedGraphData?.name;

    if (this.graphType === 'WIDTH_GRAPH' || this.graphType === 'THICKNESS_GRAPH' || this.graphType === 'CROWN_GRAPH' || this.graphType === 'WEDGE_GRAPH') {
      this.setWidthTicknessGraphConfig();
    }

  }

  /**
   * Called when drop down menu is clicked
   */
  onSelectGraphEvent(selectedGraph: { key: string; label: string; }) {

    this.selectedGraph = selectedGraph;
    if (this.coil._id && this.coil?.availableDataSetNames) {
      //PERFORMANCE FIX
      const selectedGraphData = this.coil?.coilSheetDataSets?.find(obj => obj.name === selectedGraph.key);
      if (selectedGraphData) {
        // Object with name equal to graphType exists
        this.selectedGraphData = selectedGraphData;
        this.setGraphOptions();
      }
    }
  }

  defineAnnotationsValues(dataReliabilityValues: any[], graphType: any) {
    this.annotationData = []
    // dataReliabilityValues.forEach((item, index) => {
      for (let key in dataReliabilityValues) {
      if (this.regionUnit === 'US_CUSTOMARY_UNITS') {
        key = Utility.convertMeterToFeet(+key);
      }
      if (graphType == "THICKNESS_GRAPH" || graphType == "CROWN_GRAPH" || graphType == "WEDGE_GRAPH") {

        if (dataReliabilityValues[+key] > 6) {
          this.annotationData?.push({ x: +key, fillColor: '#C1C1C1', borderColor: '#C1C1C1', strokeDashArray: 0, borderWidth: 10 })
        }
        if (dataReliabilityValues[+key] > 3 && dataReliabilityValues[+key] <= 6) {
          this.annotationData?.push({ x: +key, fillColor: '#FBE69A', borderColor: '#FBE69A', strokeDashArray: 0, borderWidth: 2 })
        }

      }
      if (graphType == "WIDTH_GRAPH") {
        if (dataReliabilityValues[+key] > 4) {
          this.annotationData?.push({ x: +key, fillColor: '#C1C1C1', borderColor: '#C1C1C1', strokeDashArray: 0, borderWidth: 10 })
        }
        if (dataReliabilityValues[+key] > 2 && dataReliabilityValues[+key] <= 4) {
          this.annotationData?.push({ x: +key, fillColor: '#FBE69A', borderColor: '#FBE69A', strokeDashArray: 0, borderWidth: 2 })
        }
      }

    }
  // );
  }

  checkDisclaimer() {
    this.showInsufficientDisclaimer = false;
    this.showMediumDisclaimer = false;
       if (this.selectedGraphData.lengthReliability) {
      if (this.selectedGraphData.lengthReliability > 5) {
        this.showInsufficientDisclaimer = true;
      } else if (this.selectedGraphData.lengthReliability > 2 && this.selectedGraphData.lengthReliability < 5) {
        this.showMediumDisclaimer = true;
      }
    }

  }


  setWidthTicknessGraphConfig() {
    this.chartOneSeries=[];
    this.cahrttwoSeries=[];
    let StringifiedValue = this.selectedGraphData?.dataSet;
    const graph: Graph | null = Utility.convertToGraph(JSON.stringify(StringifiedValue) || '');
    let upperLimit: number = 0;
    let lowerLimit: number = 0;
    let upperLimitDS: any = [];
    let lowerLimitDS: any = [];
    let chartData: any = [];
    let selection: any = {};

    this.checkDisclaimer();

    if (this.regionUnit === 'US_CUSTOMARY_UNITS') {
      if (this.graphType == "THICKNESS_GRAPH" || this.graphType == "WIDTH_GRAPH") {
        if (graph.upperLimit) upperLimit = Utility.convertMillimeterToInch(graph.upperLimit);
        if (graph.lowerLimit) lowerLimit = Utility.convertMillimeterToInch(graph.lowerLimit);
      }


      
     
      for (const key in graph?.values) {
       
        chartData.push([Utility.convertMeterToFeet(+key), Utility.convertMillimeterToInch(graph?.values[+key])]);
        if (this.graphType == "THICKNESS_GRAPH" || this.graphType == "WIDTH_GRAPH") {
          upperLimitDS.push([Utility.convertMeterToFeet(+key), upperLimit]);
          lowerLimitDS.push([Utility.convertMeterToFeet(+key), lowerLimit]);
        }
        }
      } else {
        if (this.graphType == "THICKNESS_GRAPH" || this.graphType == "WIDTH_GRAPH") {
          if (graph.upperLimit) upperLimit = +graph.upperLimit.toFixed(2);
          if (graph.lowerLimit) lowerLimit = +graph.lowerLimit.toFixed(2);
        }
        // graph?.values?.forEach((arrayvalue, index) => {
          for (const key in graph?.values) {

          if(graph?.values[+key]){
            chartData.push([+key, parseFloat(graph?.values[+key]?.toString()).toFixed(2)]);
          }else{
            chartData.push([+key, graph?.values[+key]]);
          }
         
          if (this.graphType == "THICKNESS_GRAPH" || this.graphType == "WIDTH_GRAPH") {
            upperLimitDS.push([+key, Number(upperLimit)]);
            lowerLimitDS.push([+key, Number(lowerLimit)]);
          }
  
        }
      }
      // }
    //  console.log("grapha",graph);
    //  console.log(typeof(graph))
    //   graph?.values?.forEach((arrayvalue, index) => {
    //     chartData.push([Utility.convertMeterToFeet(index), Utility.convertMillimeterToInch(arrayvalue)]);
    //     if (this.graphType == "THICKNESS_GRAPH" || this.graphType == "WIDTH_GRAPH") {
    //       upperLimitDS.push([Utility.convertMeterToFeet(index), upperLimit]);
    //       lowerLimitDS.push([Utility.convertMeterToFeet(index), lowerLimit]);
    //     }

    //   });
    // } else {
    //   if (this.graphType == "THICKNESS_GRAPH" || this.graphType == "WIDTH_GRAPH") {
    //     if (graph.upperLimit) upperLimit = +graph.upperLimit.toFixed(2);
    //     if (graph.lowerLimit) lowerLimit = +graph.lowerLimit.toFixed(2);
    //   }
    //   graph?.values?.forEach((arrayvalue, index) => {
    //     if(arrayvalue){
    //       chartData.push([index, parseFloat(arrayvalue?.toString()).toFixed(2)]);
    //     }else{
    //       chartData.push([index, arrayvalue]);
    //     }
       
    //     if (this.graphType == "THICKNESS_GRAPH" || this.graphType == "WIDTH_GRAPH") {
    //       upperLimitDS.push([index, Number(upperLimit)]);
    //       lowerLimitDS.push([index, Number(lowerLimit)]);
    //     }

    //   });
    // }

    //changes to reduce code complexity
    
    if (this.graphType === 'THICKNESS_GRAPH') {
      this.coilThicknessUpperTolerance = upperLimit;
      this.coilThicknessLowerTolerance = lowerLimit;
    }
    if (this.graphType === 'WIDTH_GRAPH') {
      this.coilWidthUpperTolerance = upperLimit;
      this.coilWidthLowerTolerance = lowerLimit;
    }
   
    if(chartData){
      this.selectionXaxislength=Number(chartData?.length)-1;
    }
    

    selection = {
      enabled: true,
      xaxis: {
        min: 0,
        max: chartData[chartData.length-1][0]
      }
    }
    this.chartOneSeries=[
        {
          showInLegend: false,
          name: `Coil ${this.selectedGraph.label}`,
          data: [...chartData]
        },
        {
          showInLegend: false,
          name: "Upper Limit",
          data: [...upperLimitDS]
        },
        {
          showInLegend: false,
          name: "Lower Limit",
          data: [...lowerLimitDS]
        }
      ];
      this.cahrttwoSeries= [
        {
          name: `Coil  ${this.selectedGraph.label}`,
          data: [...chartData]
        },
      ];
    this.defineAnnotationsValues(graph.dataReliabilityValues!, this.graphType);
    this.setChartOptions2(chartData, selection);
    this.chartOptions1 = {
      series: this.chartOneSeries,
      chart: {
        id: "chart1",
        type: "line",
        height: 200,
        width: '100%',
        toolbar: {
          show: true,
          offsetX: 0, 
          offsetY: 0,
          tools: {
            download: false,
            selection: true,
            zoom:  true,
            zoomin: true,
            zoomout: true,
            pan: false,
            reset: false,
          },
        },
      },
      annotations: { xaxis: this.annotationData },
      responsive: [
        {
          breakpoint: undefined,
          options: {},
        }
      ],
      xaxis: {
        type: 'numeric',
        tickAmount: 10,
        tickPlacement: "on",
        labels: {
          rotate: 0,
          rotateAlways: false,
          formatter: function (val: any) {
            return val.toFixed(0);
          }
        },
        decimalsInFloat: 0,
        position: 'bottom',
        title: {
          text: `Coil Length (${this.regionMeasurementUnits.length})`,
          offsetX: 0,
          offsetY: 0,
          style: {
            color: '#000000',
            fontSize: '12px',
            fontFamily: 'Helvetica, Arial, sans-serif',
            fontWeight: 300,
            cssClass: 'apexcharts-xaxis-title',
          },
        },
      },
      yaxis: {
        title: {
          text: `Coil ${this.selectedGraph.label} (${this.graphType == "CROWN_GRAPH" || this.graphType == "WEDGE_GRAPH" ? this.regionMeasurementUnits.crown_wedge : this.regionMeasurementUnits.width_thickness})`,
          offsetX: 0,
          offsetY: 0,
          style: {
            color: '#000000',
            fontSize: '12px',
            fontFamily: 'Helvetica, Arial, sans-serif',
            fontWeight: 300,
            cssClass: 'apexcharts-xaxis-title',
          },
        },
      },
      colors: ["#5e596f", "#A200A2", "#FF5DFF"],
      stroke: {
        width: [1, 1, 1],
        dashArray: [0, 2, 2]
      },
      dataLabels: {
        enabled: false
      },
      fill: {
        opacity: 1
      },
      markers: {
        size: 0
      },
      legend: {
        show: false,
      }
    };
  }
  setChartOptions2(chartData: any, selection: any) {
    this.chartOptions2 = {
      series:this.cahrttwoSeries,
      chart: {
        id: "chart2",
        height: 90,
        width: '100%',
        type: "area",
        brush: {
          target: "chart1",
          enabled: true
        },
        selection: selection
      },
      xaxis: {
        type: 'numeric',
        tickAmount: 10,
        decimalsInFloat: 0
      },
      stroke: {
        width: 1
      },
      colors: ["#A200A2"],
      fill: {
        type: "gradient",
        gradient: {
          opacityFrom: 0.91,
          opacityTo: 0.1
        }
      },
    };
  }
}